import {request} from './request'
import store from '../store'
const jmkApi ={
  //列表
  getList:params=>{
    let user_id = 0;
    if (store.state.userInfo && store.state.userInfo.id){
      user_id = store.state.userInfo.id
    }
    let params2={
      page:params.page,
      pageSize:params.pageSize || 8,
      type_id:params.type_id || -1, //节目分类id,2,4,6,8,10
      subtype_id:params.subtype_id || -1, //
      brand_id:params.brand_id || -1,//品牌id
      activity_id:params.activity_id || -1,  //根据活动id
      is_top:params.is_top || -1,  //是否置顶
      is_award:params.is_award>=0?params.is_award:-1,//是否获奖 1，-1
      level:params.level || -1,  //国家级
      city:params.city || '', // 城市
      task_year:params.task_year || '', //年限
      keywords:params.keywords || '',
      channel_ids:params.channel_ids || "", //题材
      showtype:params.showtype || '', //展示类型-视频图片
      programform:params.programform || '',//节目形式
      award:params.award ||'',//奖项
      type_tag:params.type_tag ||'',//分类标签
      recommend: params.recommend ? params.recommend : -1,  //是否推荐
      // user_id:params.user_id || 0
      user_id: user_id
    }
    if (params.is_sort) {
      params2.is_sort = params.is_sort
    }
    // console.log(params2);
    return request({url: '/ShowApi/GetList',params:params2});
  },
  

  //单一节目内容
  getOneById:params=>{
    // id
    return request({url: '/ShowApi/GetById',params:params,});
  },
  //单一节目右侧的演员信息
  getOneOtherInfo:params=>{
    return request({url: '/ShowApi/GetArtistListNameById',params:params,});
  },

  //根据人才id找节目
  getShowlistbyArtist:params=>{
    let user_id = 0;
    if (store.state.userInfo && store.state.userInfo.id) {
      user_id = store.state.userInfo.id
    }
    let params2 ={
      ...params,
      user_id
    }
    return request({ url: '/ShowApi/GetShowListByArtistId', params: params2,})
  },

  //节目题材
  getProgramTheme:()=>{
    let params2={
      parentId:72
    }
    return request({url:'/ChannelApi/GetListByParentId',params:params2})
  },
  //节目形式
  getProgramFormList:params=>{
    return request({url:'/ShowApi/GetProgramformList',params:params})
  },

  // 根据级别是否显示加载数据
  getGrantInfo:params=>{
    let params2 ={
      user_id:params.user_id,
      show_id:params.show_id,
      ip:window.ip
    }
    return request({url:'/UsersApi/GetGrantInfo',params:params2})
  },
  // 后台预览详情页
  GetByIdShow: params =>{
    return request({ url: "showApi/getByIdShow", params: params})
  },
  
  // 获奖信息列表
  GetAwardsList: params =>{
    return request({ url: "/ShowApi/GetAwards", params: params})
  }
}

export default jmkApi